import React,{useEffect,useState} from 'react';
import './today-home-overview.css';

const compactQuery='(min-width:1101px) and (max-height:780px)';
export default function TodayOverview({summary,collections}) {
 const [compact,setCompact]=useState(()=>window.matchMedia?.(compactQuery).matches||false);
 const [page,setPage]=useState(0);
 useEffect(()=>{
  if(!window.matchMedia)return undefined;
  const media=window.matchMedia(compactQuery);
  const update=()=>{setCompact(media.matches);setPage(0);};
  media.addEventListener('change',update);
  return()=>media.removeEventListener('change',update);
 },[]);
 return <div className={`today-home-overview${compact?' is-paged':''}`}>
  <div className="today-dashboard__grid">
   {(!compact||page===0)&&summary}
   {(!compact||page===1)&&collections}
  </div>
  {compact&&<nav className="today-home-overview__pages" aria-label="Today overview pages">
   <button type="button" aria-label="Previous overview page" disabled={page===0} onClick={()=>setPage(0)}>Previous</button>
   <span aria-live="polite">{page===0?'Today overview':'Trophies & celebrations'} · {page+1} / 2</span>
   <button type="button" aria-label="Next overview page" disabled={page===1} onClick={()=>setPage(1)}>Next</button>
  </nav>}
 </div>;
}
